import { Link, useLocation } from 'react-router-dom';

const tabs = [
  ['/radar/housing', '청약정보'],
  ['/radar/bids', '공고·입찰'],
  ['/radar/support', '지원사업'],
  ['/radar/commercial-areas', '상권 경쟁'],
] as const;

export function RadarProductTabs() {
  const location = useLocation();
  return (
    <nav className="radar-product-tabs radar-product-tabs-global" aria-label="비즈니스 레이더 정보탭">
      {tabs.map(([route, label]) => (
        <Link key={route} className={location.pathname === route ? 'radar-product-tab-active' : ''} to={route}>
          {label}
        </Link>
      ))}
    </nav>
  );
}
